import React, { useEffect, useState } from "react";
import authService from "../../../services/auth/auth.service";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../../components/shared/Input/CustomInput";
import useGlobalState from "../../../context/GlobalState";
import { HttpStatusCode } from "../../../models/HttpStatusCodes";
import useIsMobile from "../../../hooks/useIsMobile";
import "./Login.css";

const Login = () => {
    const navigation = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const isMobile = useIsMobile();
    const { setAlert, isLogged } = useGlobalState();

    const handleLogin = async () => {
        let res = await authService.login(email, password);

        if (res.status === HttpStatusCode.Unauthorized) {
            setAlert("Usuario o contraseña incorrectos", "error");
        }
    }

    const handleLogut = () => {
        authService.logout();
    }

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    }

    useEffect(() => {
        if (window.location.pathname.includes("logout")) {
            handleLogut();
            navigation("/admin/login");
        }
    }, []);

    useEffect(() => {
        if (isLogged === true) {
            navigation("/admin/forms/projects");
        }
    }, [isLogged]);

    return (
        <div className="login">
            <div className="login-container" style={isMobile ? { justifyContent: 'space-evenly' } : {}}>
                <img src='/emprendedores/UABClogos/FCITEC.png' alt='logo' />
                <div className='form-container'>
                    <h1>Inicio de Sesion</h1>
                    <div className="input-container">
                        <CustomInput label="Email" type="email" field="Correo" value={email} onChange={setEmail} />
                    </div>
                    <div className="input-container">
                        <CustomInput label="Password" type="password" field="Contraseña" value={password} onChange={setPassword} onKeyDown={handleKeyDown}/>
                    </div>
                </div>
                <button onClick={handleLogin} className="btn-login">Iniciar Sesion</button>
            </div>
        </div>
    );
}

export default Login;